const SCOUT = {
  LOADING_SEARCH: "LOADING_SEARCH",
  SEARCH_APPLICATION: "SEARCH_APPLICATION",
};

export default SCOUT;
